import { FSharpRef, Record } from "./fable_modules/fable-library.4.10.0/Types.js";
import { IAudApi, IRegApi, ITeamApi, IAdminApi, IMainApi, ISecurityApi, Errors_SessionIsNotActive, Settings_$reflection, User_$reflection, IAudApi_$reflection, IRegApi_$reflection, ITeamApi_$reflection, IAdminApi_$reflection, IMainApi_$reflection, ISecurityApi_$reflection, Infra_routeBuilder, MediaType, REQ$1, RESP$1_$reflection } from "../shared/Shared.fs.js";
import { class_type, bool_type, string_type, record_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { add, utcNow, op_Subtraction } from "./fable_modules/fable-library.4.10.0/Date.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { tail as tail_1, head as head_1, isEmpty, ofArray } from "./fable_modules/fable-library.4.10.0/List.js";
import { Cmd_OfAsyncWith_either } from "./fable_modules/Fable.Elmish.5.0.2/./cmd.fs.js";
import { AsyncHelpers_start } from "./fable_modules/Fable.Elmish.5.0.2/./prelude.fs.js";
import { singleton } from "./fable_modules/fable-library.4.10.0/AsyncBuilder.js";
import { split, replace, isNullOrEmpty, substring, toText, printf, toConsole } from "./fable_modules/fable-library.4.10.0/String.js";
import { map, choose, singleton as singleton_1, append, collect, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import * as react from "react";
import { catchAsync, fromContinuations } from "./fable_modules/fable-library.4.10.0/Async.js";
import { some } from "./fable_modules/fable-library.4.10.0/Option.js";
import { tryParse } from "./fable_modules/fable-library.4.10.0/Int32.js";
import { tryParse as tryParse_1 } from "./fable_modules/fable-library.4.10.0/Decimal.js";
import Decimal from "./fable_modules/fable-library.4.10.0/Decimal.js";
import { Remoting_buildProxy_64DC51C } from "./fable_modules/Fable.Remoting.Client.7.35.0/./Remoting.fs.js";
import { RemotingModule_createApi, RemotingModule_withBaseUrl, RemotingModule_withRouteBuilder } from "./fable_modules/Fable.Remoting.Client.7.35.0/Remoting.fs.js";
import { Languages } from "./L10n.fs.js";
import { comparePrimitives, defaultOf } from "./fable_modules/fable-library.4.10.0/Util.js";
import { Convert_fromJson, Convert_serialize } from "./fable_modules/Fable.SimpleJson.3.24.0/./Json.Converter.fs.js";
import { createTypeInfo } from "./fable_modules/Fable.SimpleJson.3.24.0/./TypeInfo.Converter.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.4.10.0/Choice.js";
import { SimpleJson_tryParse } from "./fable_modules/Fable.SimpleJson.3.24.0/./SimpleJson.fs.js";
import { empty, ofSeq } from "./fable_modules/fable-library.4.10.0/Map.js";
import { equalsWith } from "./fable_modules/fable-library.4.10.0/Array.js";

export class TRESP$2 extends Record {
    constructor(Tag, Rsp) {
        super();
        this.Tag = Tag;
        this.Rsp = Rsp;
    }
}

export function TRESP$2_$reflection(gen0, gen1) {
    return record_type("Common.TRESP`2", [gen0, gen1], TRESP$2, () => [["Tag", gen0], ["Rsp", RESP$1_$reflection(gen1)]]);
}

export class DeleteForm extends Record {
    constructor(ConfirmText, FormError, IsSending) {
        super();
        this.ConfirmText = ConfirmText;
        this.FormError = FormError;
        this.IsSending = IsSending;
    }
}

export function DeleteForm_$reflection() {
    return record_type("Common.DeleteForm", [], DeleteForm, () => [["ConfirmText", string_type], ["FormError", string_type], ["IsSending", bool_type]]);
}

export function timeDiff(serverTime_1) {
    return op_Subtraction(serverTime_1, utcNow());
}

export function serverTime(timeDiff_1) {
    return add(utcNow(), timeDiff_1);
}

export function compareDates(d1, d2) {
    return op_Subtraction(d1, d2);
}

export function noCmd(model) {
    return [model, Cmd_none()];
}

export function batchCmd(cmd1, model, cmd2) {
    return [model, Cmd_batch(ofArray([cmd1, cmd2]))];
}

export function apiCmd(proc, arg, ofSucccess, ofExn, model) {
    return [model, Cmd_OfAsyncWith_either((x) => {
        AsyncHelpers_start(x);
    }, proc, Infra_REQ(arg), ofSucccess, ofExn)];
}

export function apiCmd$0027(proc, arg, ofSucccess, ofExn) {
    return Cmd_OfAsyncWith_either((x) => {
        AsyncHelpers_start(x);
    }, proc, Infra_REQ(arg), ofSucccess, ofExn);
}

export function timeoutCmd(msg, timeout) {
    let isTickScheduled = false;
    return Cmd_ofEffect((dispatch) => {
        if (!isTickScheduled) {
            isTickScheduled = true;
            window.setTimeout((_arg) => {
                isTickScheduled = false;
                dispatch(msg);
            }, timeout);
        }
    });
}

export function uploadFileToS3Cmd(getUrlMethod, cat, file, onSuccess, onError) {
    return Cmd_OfAsyncWith_either((x) => {
        AsyncHelpers_start(x);
    }, () => singleton.Delay(() => singleton.Bind(getUrlMethod(new REQ$1("", {
        Cat: cat,
    })), (_arg) => {
        const resp = _arg;
        if (resp.Value.tag === 1) {
            return singleton.Return((() => {
                throw new Error(resp.Value.fields[0]);
            })());
        }
        else {
            const res = resp.Value.fields[0];
            return singleton.Bind(uploadFileToS3(file, res.Url), (_arg_1) => singleton.Return(res.BucketKey));
        }
    })), void 0, onSuccess, onError);
}

export function mediaTypeFromMiME(mime) {
    toConsole(printf("MIME: %s"))(mime);
    const mime_1 = mime.toLocaleLowerCase();
    if (mime_1.indexOf("audio") === 0) {
        return new MediaType(1, []);
    }
    else if (mime_1.indexOf("video") === 0) {
        return new MediaType(2, []);
    }
    else {
        return new MediaType(0, []);
    }
}

export function urlForTeam(quizId, teamId, token) {
    const arg = Infra_locationFullPath();
    return toText(printf("%s?who=team&quiz=%d&team=%d&token=%s"))(arg)(quizId)(teamId)(token);
}

export function urlForAdmin(quizId, token) {
    const arg = Infra_locationFullPath();
    return toText(printf("%s?who=admin&quiz=%d&token=%s"))(arg)(quizId)(token);
}

export function urlForReg(quizId, token) {
    const arg = Infra_locationFullPath();
    return toText(printf("%s?who=reg&quiz=%d&token=%s"))(arg)(quizId)(token);
}

export function urlForAud(quizId, token) {
    const arg = Infra_locationFullPath();
    return toText(printf("%s?who=aud&quiz=%d&token=%s"))(arg)(quizId)(token);
}

export function urlForResults(quizId, quizName, quizImgKey, resultsToken, mediaHost) {
    return toText(printf("/results.html?who=res&quiz=%d&quizName=%s&quizImg=%s&token=%s&url=%s"))(quizId)(quizName)(quizImgKey)(resultsToken)(mediaHost);
}

export function urlForResultsIframe(quizId, resultsToken, teamId, mediaHost) {
    const url = toText(printf("/results.html?who=emb&quiz=%d&token=%s&url=%s"))(quizId)(resultsToken)(mediaHost);
    if (teamId == null) {
        return url;
    }
    else {
        const id = teamId | 0;
        return url + toText(printf("&teamId=%d"))(id);
    }
}

export function splitByLines(txt) {
    return toList(delay(() => collect((l) => append(singleton_1(l), delay(() => singleton_1(react.createElement("br", {})))), txt.split("\n"))));
}

export function fileOnChangeAsText(tag, callback, ev) {
    const files = ev.target["files"];
    const file = files[0];
    const reader = new FileReader();
    reader.onload = ((_arg) => {
        let Name;
        callback((Name = file.name, {
            Body: reader.result,
            Name: Name,
            Tag: tag,
        }));
    });
    reader.readAsText(file);
}

export function fileOnChangeForS3(tag, callback, ev) {
    const files = ev.target["files"];
    return callback({
        File: files[0],
        Tag: tag,
    });
}

export function uploadFileToS3(file, presignedUrl) {
    return fromContinuations((tupledArg) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", presignedUrl);
        xhr.onreadystatechange = (() => {
            const matchValue = xhr.readyState | 0;
            if (matchValue === 4) {
                if (xhr.status === 200) {
                    tupledArg[0](xhr.responseText);
                }
                else {
                    throw new Error(xhr.responseText);
                }
            }
        });
        xhr.send(some(file));
    });
}

export function download(fileName, contentType, content) {
    const anchor = document.createElement("a");
    const encodedContent = encodeURI(`data:${contentType};charset=utf-8,${content}`);
    anchor.setAttribute("href", encodedContent);
    anchor.setAttribute("download", fileName);
    anchor.click();
}

export function taggedMsg(msg, tag, rsp) {
    return msg(new TRESP$2(tag, rsp));
}

export function ofInt(value) {
    if (value == null) {
        return void 0;
    }
    else {
        let matchValue;
        let outArg = 0;
        matchValue = [tryParse(value, 511, false, 32, new FSharpRef(() => outArg, (v_1) => {
            outArg = (v_1 | 0);
        })), outArg];
        if (matchValue[0]) {
            return matchValue[1];
        }
        else {
            return void 0;
        }
    }
}

export function ofDecimal(value) {
    if (value == null) {
        return void 0;
    }
    else {
        let matchValue;
        let outArg = new Decimal("0");
        matchValue = [tryParse_1(value, new FSharpRef(() => outArg, (v_1) => {
            outArg = v_1;
        })), outArg];
        if (matchValue[0]) {
            return matchValue[1];
        }
        else {
            return void 0;
        }
    }
}

export function trimEnd(n, suffix, str) {
    if (str.length < n) {
        return str;
    }
    else {
        return substring(str, 0, n) + suffix;
    }
}

export function trimMiddle(n, suffix, str) {
    if (str.length < n) {
        return str;
    }
    else {
        return (substring(str, 0, ~~(n / 2)) + suffix) + substring(str, str.length - ~~(n / 2), ~~(n / 2));
    }
}

export function DeleteForm_CreateEmpty() {
    return new DeleteForm("", "", false);
}

export function DeleteForm_Toggle_Z5CE7ED6(form) {
    if (form == null) {
        return DeleteForm_CreateEmpty();
    }
    else {
        return void 0;
    }
}

export class Infra_ApiFactory {
    constructor(switchToLoginAction) {
        this.switchToLoginAction = switchToLoginAction;
        const o = sessionStorage.getItem("TOKEN");
        this.token = ((o == null) ? "" : o);
        const o_1 = sessionStorage.getItem("REFRESH_TOKEN");
        this.refreshToken = ((o_1 == null) ? "" : o_1);
        this.securityApi = Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder((typeName, methodName) => Infra_routeBuilder("", typeName, methodName), RemotingModule_withBaseUrl("/", RemotingModule_createApi())), ISecurityApi_$reflection());
        this.mainApi = Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder((typeName_1, methodName_1) => Infra_routeBuilder("", typeName_1, methodName_1), RemotingModule_withBaseUrl("/", RemotingModule_createApi())), IMainApi_$reflection());
        this.adminApi = Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder((typeName_2, methodName_2) => Infra_routeBuilder("", typeName_2, methodName_2), RemotingModule_withBaseUrl("/", RemotingModule_createApi())), IAdminApi_$reflection());
        this.teamApi = Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder((typeName_3, methodName_3) => Infra_routeBuilder("", typeName_3, methodName_3), RemotingModule_withBaseUrl("/", RemotingModule_createApi())), ITeamApi_$reflection());
        this.regApi = Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder((typeName_4, methodName_4) => Infra_routeBuilder("", typeName_4, methodName_4), RemotingModule_withBaseUrl("/", RemotingModule_createApi())), IRegApi_$reflection());
        this.audApi = Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder((typeName_5, methodName_5) => Infra_routeBuilder("", typeName_5, methodName_5), RemotingModule_withBaseUrl("/", RemotingModule_createApi())), IAudApi_$reflection());
    }
}

export function Infra_ApiFactory_$reflection() {
    return class_type("Common.Infra.ApiFactory", void 0, Infra_ApiFactory);
}

export function Infra_ApiFactory_$ctor_3A5B6456(switchToLoginAction) {
    return new Infra_ApiFactory(switchToLoginAction);
}

export function Infra_locationFullPath() {
    return (window.location.origin) + (window.location.pathname);
}

export function Infra_getPreferableLangugage() {
    const check = (langs_mut) => {
        check:
        while (true) {
            const langs = langs_mut;
            if (isEmpty(langs)) {
                return new Languages(0, []);
            }
            else {
                let matchValue;
                const lang_1 = head_1(langs).toLowerCase();
                matchValue = ((lang_1.indexOf("en") === 0) ? (new Languages(0, [])) : ((lang_1.indexOf("ru") === 0) ? (new Languages(1, [])) : ((lang_1.indexOf("uk") === 0) ? (new Languages(2, [])) : ((lang_1.indexOf("az") === 0) ? (new Languages(3, [])) : ((lang_1.indexOf("uz") === 0) ? (new Languages(4, [])) : void 0)))));
                if (matchValue == null) {
                    langs_mut = tail_1(langs);
                    continue check;
                }
                else {
                    return matchValue;
                }
            }
            break;
        }
    };
    return check(ofArray(window.navigator.languages));
}

export function Infra_getUrlHashParts() {
    const hash = window.location.hash;
    if (isNullOrEmpty(hash)) {
        return ["", ""];
    }
    else {
        const idxOfCol = hash.indexOf(":") | 0;
        if (idxOfCol === -1) {
            return [hash, ""];
        }
        else {
            return [substring(hash, 0, idxOfCol), substring(hash, idxOfCol)];
        }
    }
}

export function Infra_urlWithNewHash(hash) {
    if (Infra_getUrlHashParts()[0] !== hash) {
        return replace(window.location.href, window.location.hash, hash);
    }
    else {
        return window.location.href;
    }
}

export function Infra_urlWithNewHashQuery(query) {
    const hashTag = Infra_getUrlHashParts()[0];
    if (hashTag !== "") {
        return replace(window.location.href, window.location.hash, hashTag + query);
    }
    else {
        return window.location.href;
    }
}

export function Infra_redirect(url) {
    window.location.replace(url);
}

export function Infra_clearQueryString() {
    history.pushState(defaultOf(), "", window.location.href.split("?")[0]);
}

export function Infra_removeFromLocalStorage(key) {
    localStorage.removeItem(key);
}

export function Infra_saveUser(user) {
    sessionStorage.setItem("USER", Convert_serialize(user, createTypeInfo(User_$reflection())));
}

export function Infra_loadUser() {
    let matchValue_1;
    const str = sessionStorage.getItem("USER");
    let matchValue;
    try {
        matchValue = (new FSharpResult$2(0, [(matchValue_1 = SimpleJson_tryParse(str), (matchValue_1 != null) ? Convert_fromJson(matchValue_1, createTypeInfo(User_$reflection())) : (() => {
            throw new Error("Couldn\'t parse the input JSON string because it seems to be invalid");
        })())]));
    }
    catch (ex) {
        matchValue = (new FSharpResult$2(1, [ex.message]));
    }
    if (matchValue.tag === 1) {
        return void 0;
    }
    else {
        return matchValue.fields[0];
    }
}

export function Infra_saveSettings(settings) {
    sessionStorage.setItem("SETTINGS", Convert_serialize(settings, createTypeInfo(Settings_$reflection())));
}

export function Infra_loadSettings() {
    let matchValue_1;
    const str = sessionStorage.getItem("SETTINGS");
    let matchValue;
    try {
        matchValue = (new FSharpResult$2(0, [(matchValue_1 = SimpleJson_tryParse(str), (matchValue_1 != null) ? Convert_fromJson(matchValue_1, createTypeInfo(Settings_$reflection())) : (() => {
            throw new Error("Couldn\'t parse the input JSON string because it seems to be invalid");
        })())]));
    }
    catch (ex) {
        matchValue = (new FSharpResult$2(1, [ex.message]));
    }
    if (matchValue.tag === 1) {
        return void 0;
    }
    else {
        return matchValue.fields[0];
    }
}

export function Infra_clearUserAndSettingsAndRedirect(url) {
    sessionStorage.removeItem("USER");
    sessionStorage.removeItem("SETTINGS");
    Infra_redirect(url);
}

export function Infra_currentQueryString() {
    const querystring = window.location.search;
    if (querystring.length > 1) {
        return ofSeq(choose((x_1) => x_1, map((segment) => {
            const matchValue = split(segment, ["="], 2);
            if (!equalsWith((x, y) => (x === y), matchValue, defaultOf()) && (matchValue.length === 2)) {
                const value = matchValue[1];
                return [matchValue[0], value];
            }
            else {
                return void 0;
            }
        }, split(substring(querystring, 1), ["&"], void 0, 0))), {
            Compare: comparePrimitives,
        });
    }
    else {
        return empty({
            Compare: comparePrimitives,
        });
    }
}

export function Infra_REQ(arg) {
    return new REQ$1("", arg);
}

export function Infra_ApiFactory__RefreshTokenAndProceed_Z721C83C5(x, failedToken) {
    return singleton.Delay(() => {
        if (failedToken !== x.token) {
            return singleton.Return(x.token);
        }
        else {
            const req = new REQ$1(x.token, {
                RefreshToken: x.refreshToken,
            });
            return singleton.Bind(x.securityApi.refreshToken(req), (_arg) => {
                const resp = _arg;
                let matchResult, res;
                if (resp.Status.tag === 0) {
                    const copyOfStruct = resp.Value;
                    if (copyOfStruct.tag === 0) {
                        matchResult = 0;
                        res = copyOfStruct.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0: {
                        Infra_ApiFactory__UpdateTokens(x, res.Token, res.RefreshToken);
                        return singleton.Return(x.token);
                    }
                    default:
                        return singleton.Return(void 0);
                }
            });
        }
    });
}

function Infra_ApiFactory__Rpc(x, f, req) {
    return singleton.Delay(() => singleton.Bind(catchAsync(f(req)), (_arg) => {
        const r = _arg;
        return (r.tag === 1) ? singleton.Return((() => {
            throw r.fields[0];
        })()) : singleton.Return(r.fields[0]);
    }));
}

export function Infra_ApiFactory__Wrap(x, f, req) {
    return singleton.Delay(() => {
        const req_1 = new REQ$1(x.token, req.Arg);
        return singleton.Bind(Infra_ApiFactory__Rpc(x, f, req_1), (_arg) => {
            let matchValue;
            const resp = _arg;
            let realR = resp;
            return singleton.Combine((matchValue = resp.Status, (matchValue.tag === 1) ? ((x.switchToLoginAction(), singleton.Zero())) : ((matchValue.tag === 2) ? singleton.Bind(Infra_ApiFactory__RefreshTokenAndProceed_Z721C83C5(x, req_1.Token), (_arg_1) => {
                const newToken = _arg_1;
                if (newToken == null) {
                    x.switchToLoginAction();
                    return singleton.Zero();
                }
                else {
                    const token = newToken;
                    return singleton.Bind(Infra_ApiFactory__Rpc(x, f, new REQ$1(token, req_1.Arg)), (_arg_2) => {
                        let matchValue_1;
                        const newResp = _arg_2;
                        return singleton.Combine((matchValue_1 = newResp.Status, (matchValue_1.tag === 1) ? ((x.switchToLoginAction(), singleton.Zero())) : ((matchValue_1.tag === 2) ? ((x.switchToLoginAction(), singleton.Zero())) : (singleton.Zero()))), singleton.Delay(() => {
                            realR = newResp;
                            return singleton.Zero();
                        }));
                    });
                }
            }) : (singleton.Zero()))), singleton.Delay(() => {
                const matchValue_2 = realR.Value;
                let matchResult;
                if (matchValue_2.tag === 1) {
                    if (matchValue_2.fields[0] === Errors_SessionIsNotActive) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return singleton.Return((() => {
                            throw new Error(Errors_SessionIsNotActive);
                        })());
                    default:
                        return singleton.Return(realR);
                }
            }));
        });
    });
}

export function Infra_ApiFactory__UpdateTokens(x, newToken, newRefreshToken) {
    x.token = newToken;
    x.refreshToken = newRefreshToken;
    sessionStorage.setItem("TOKEN", x.token);
    sessionStorage.setItem("REFRESH_TOKEN", x.refreshToken);
}

export function Infra_ApiFactory__CreateSecurityApi(x) {
    return new ISecurityApi((req) => Infra_ApiFactory__Wrap(x, x.securityApi.login, req), (req_1) => Infra_ApiFactory__Wrap(x, x.securityApi.refreshToken, req_1));
}

export function Infra_ApiFactory__CreateMainApi(x) {
    return new IMainApi((req) => Infra_ApiFactory__Wrap(x, x.mainApi.becomeProducer, req), (req_1) => Infra_ApiFactory__Wrap(x, x.mainApi.createQuiz, req_1), (req_2) => Infra_ApiFactory__Wrap(x, x.mainApi.getProdQuizzes, req_2), (req_3) => Infra_ApiFactory__Wrap(x, x.mainApi.getProdQuizCard, req_3), (req_4) => Infra_ApiFactory__Wrap(x, x.mainApi.updateProdQuizCard, req_4), (req_12) => Infra_ApiFactory__Wrap(x, x.mainApi.deleteQuiz, req_12), (req_5) => Infra_ApiFactory__Wrap(x, x.mainApi.getRegModel, req_5), (req_6) => Infra_ApiFactory__Wrap(x, x.mainApi.registerTeam, req_6), (req_7) => Infra_ApiFactory__Wrap(x, x.mainApi.getProdPackages, req_7), (req_8) => Infra_ApiFactory__Wrap(x, x.mainApi.getProdPackageCard, req_8), (req_9) => Infra_ApiFactory__Wrap(x, x.mainApi.createPackage, req_9), (req_10) => Infra_ApiFactory__Wrap(x, x.mainApi.updateProdPackageCard, req_10), (req_11) => Infra_ApiFactory__Wrap(x, x.mainApi.aquirePackage, req_11), (req_13) => Infra_ApiFactory__Wrap(x, x.mainApi.deletePackage, req_13), (req_14) => Infra_ApiFactory__Wrap(x, x.mainApi.getSettings, req_14), (req_15) => Infra_ApiFactory__Wrap(x, x.mainApi.updateSettings, req_15), (req_16) => Infra_ApiFactory__Wrap(x, x.mainApi.sharePackage, req_16), (req_17) => Infra_ApiFactory__Wrap(x, x.mainApi.removePackageShare, req_17), (req_18) => Infra_ApiFactory__Wrap(x, x.mainApi.getUploadUrl, req_18));
}

export function Infra_ApiFactory__CreateAdminApi(x) {
    return new IAdminApi((req) => Infra_ApiFactory__Wrap(x, x.adminApi.getTeams, req), (req_1) => Infra_ApiFactory__Wrap(x, x.adminApi.createTeam, req_1), (req_2) => Infra_ApiFactory__Wrap(x, x.adminApi.createTeamBatch, req_2), (req_3) => Infra_ApiFactory__Wrap(x, x.adminApi.getTeamCard, req_3), (req_4) => Infra_ApiFactory__Wrap(x, x.adminApi.updateTeamCard, req_4), (req_5) => Infra_ApiFactory__Wrap(x, x.adminApi.changeTeamStatus, req_5), (req_6) => Infra_ApiFactory__Wrap(x, x.adminApi.getQuizCard, req_6), (req_7) => Infra_ApiFactory__Wrap(x, x.adminApi.changeQuizStatus, req_7), (req_8) => Infra_ApiFactory__Wrap(x, x.adminApi.changeStreamUrl, req_8), (req_9) => Infra_ApiFactory__Wrap(x, x.adminApi.getPackages, req_9), (req_10) => Infra_ApiFactory__Wrap(x, x.adminApi.setPackage, req_10), (req_11) => Infra_ApiFactory__Wrap(x, x.adminApi.getPackageCard, req_11), (req_12) => Infra_ApiFactory__Wrap(x, x.adminApi.startCountDown, req_12), (req_13) => Infra_ApiFactory__Wrap(x, x.adminApi.pauseCountDown, req_13), (req_14) => Infra_ApiFactory__Wrap(x, x.adminApi.settleTour, req_14), (req_15) => Infra_ApiFactory__Wrap(x, x.adminApi.nextTour, req_15), (req_16) => Infra_ApiFactory__Wrap(x, x.adminApi.nextQuestion, req_16), (req_17) => Infra_ApiFactory__Wrap(x, x.adminApi.nextQuestionPart, req_17), (req_18) => Infra_ApiFactory__Wrap(x, x.adminApi.showMedia, req_18), (req_19) => Infra_ApiFactory__Wrap(x, x.adminApi.showQuestion, req_19), (req_20) => Infra_ApiFactory__Wrap(x, x.adminApi.getAnswers, req_20), (req_21) => Infra_ApiFactory__Wrap(x, x.adminApi.updateResults, req_21), (req_22) => Infra_ApiFactory__Wrap(x, x.adminApi.updateResultsWithoutAnswer, req_22), (req_23) => Infra_ApiFactory__Wrap(x, x.adminApi.getListenToken, req_23));
}

export function Infra_ApiFactory__CreateTeamApi(x) {
    return new ITeamApi((req) => Infra_ApiFactory__Wrap(x, x.teamApi.getState, req), (req_1) => Infra_ApiFactory__Wrap(x, x.teamApi.takeActiveSession, req_1), (req_2) => Infra_ApiFactory__Wrap(x, x.teamApi.answers, req_2), (req_3) => Infra_ApiFactory__Wrap(x, x.teamApi.getHistory, req_3), (req_4) => Infra_ApiFactory__Wrap(x, x.teamApi.vote, req_4));
}

export function Infra_ApiFactory__CreateRegApi(x) {
    return new IRegApi((req) => Infra_ApiFactory__Wrap(x, x.regApi.getRecord, req));
}

export function Infra_ApiFactory__CreateAudApi(x) {
    return new IAudApi((req) => Infra_ApiFactory__Wrap(x, x.audApi.getQuiz, req), (req_1) => Infra_ApiFactory__Wrap(x, x.audApi.getHistory, req_1));
}

